/**
 * mode types for FlowDetailActions component
 * Determines which menu items should be shown or hidden
 *
 * This extends the pattern of prop-based visibility control (like insightsOnly)
 * to be more declarative and context-aware.
 */
export const FlowDetailActionsMode = {
  /** Default: Show all menu items */
  DEFAULT: 'DEFAULT',
  /** Insights only: Show only Flow Insights menu item */
  INSIGHTS_ONLY: 'INSIGHTS_ONLY',
  /** Resource triage view: May have different restrictions */
  RESOURCE_TRIAGE: 'RESOURCE_TRIAGE',
} as const;

export type FlowDetailActionsModeType =
  (typeof FlowDetailActionsMode)[keyof typeof FlowDetailActionsMode];
